<template>
	<el-container class="full">
		<!-- 侧边 -->
		<el-aside width="200px">
			<side-bar>
				<div slot="trademark" class="title-box">
					<!-- <img src="../assets/images/ic_home_logo.png"> -->
				</div>
				<div slot="router">
					<component v-for="item in menuList" :key="item.name" :data="item"
						:is="(item.children && item.children.length)?'sub-menu':'menu-item'" />
				</div>
			</side-bar>
		</el-aside>
		<el-container class="full-height bg-gray">
			<!-- 头部 -->
			<el-header class="no-padding index-header" style="height:73px;z-index: 1999;">
				<top-bar />
			</el-header>
			<!-- 主体 -->
			<div class="main">
				<router-view class="content" />
			</div>
		</el-container>
	</el-container>
</template>
<script>
	/* eslint-disable space-infix-ops */

	import TopBar from "../components/TopBar";
	import SideBar from "../components/side-bar";
	import MenuItem from "../components/side-bar/menu-item";
	import SubMenu from "../components/side-bar/sub-menu";
	import {
		pms2MenuList,
		decrypt
	} from "../filters/filter";
	import {
		mapState
	} from "vuex";

	export default {
		name: "Index",
		data() {
			return {
				menuList: [],
				menuList: [{
						iconClass: 'icon-autn-manage',
						name: '系统配置',
						url: '/user-list',
						children: [{
							name: '成员管理',
							url: '/user-list'
						}]
					}, {
						iconClass: 'icon-autn-manage',
						name: '内容管理',
						url: '/content-manage',
						children: [{
							name: '视频管理',
							url: '/video-list'
						}, {
							name: '专利管理',
							url: '/patent-list'
						}, {
							name: '标准',
							url: '/standard-list'
						}, {
							name: '奖励',
							url: '/award-list'
						}, {
							name: '荣誉',
							url: '/honor-list'
						}, {
							name: '资质',
							url: '/qualit-list'
						}, {
							name: '检测报告',
							url: '/detection-list'
						}, {
							name: '宣传页',
							url: '/publicy-list'
						}, {
							name: '公司介绍',
							url: '/company-list'
						}]
					},
					{
						iconClass: 'icon-autn-manage',
						name: '百草学院',
						url: '/school-manage',
						children: [{
							name: '分类管理',
							url: '/category-list'
						}, {
							name: '百草资讯',
							url: '/news-list'
						}]
					},
					{
						iconClass: 'icon-autn-manage',
						name: '知识库管理',
						url: '/city-list',
						children: [{
							name: '知识库列表',
							url: '/city-list'
						}]
					},
					{
						iconClass: 'icon-autn-manage',
						name: 'AI应用管理',
						url: '/ai-app-list',
						children: [{
							name: '应用列表',
							url: '/ai-app-list'
						}]
					},
				],
				newOrders: [],
				dialogVisible: false,
				timer: null
			};
		},
		components: {
			TopBar,
			SideBar,
			MenuItem,
			SubMenu
		},
		created() {
			const encryptedPermission = sessionStorage.getItem('permission')
			// this.menuList = JSON.parse(encryptedPermission);
			// this.menuList = this.menuList.concat(JSON.parse(encryptedPermission));
			// this.menuList = pms2MenuList(JSON.parse(decrypt(this.permissionList)));
			console.log(this.menuList)
		},
		mounted() {},
		methods: {
			notification(item) {
				let that = this;
				Notification.requestPermission().then(function(result) {
					if (result == "granted") {
						var notification = new Notification("酒店管理后台管理员：", {
							body: `你有新的订单，请及时处理`,
							icon: "https://hotel-cdn.yxhotel.vip/FoNiwhNNUJMqf9pil87b6nw7cC2A"
						});
						// notification.onclick = function() {
						//   // window.open('https://web-hotel-manage-admin.gymooit.cn/#/order-list')
						//   let route = that.$router.resolve({
						//     name: "order-list"
						//   });
						//   window.open(route.href, "_blank");
						// };
					}
				});
			}
		},
		computed: {
			...mapState(["permissionList"])
		},
		watch: {}
	};
</script>

<style lang="less">
	.index-header {
		position: absolute;
		// background: rgba(7, 19, 62, 1);
		z-index: 2;
	}

	.el-header {
		padding-left: 0;
	}
</style>
<style lang="less" scoped>
	.title-box {
		// font-size: 18px;
		// color: #000;
		// display: flex;
		// align-items: center;
		// justify-content: center;
		width: 200px;
		height: 73px;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.full-height {
		height: 100vh;
		overflow: hidden;
		overflow-y: auto;
	}

	.main .content {
		padding: 20px 50px 40px 50px;
		margin-top: 73px;
	}

	.news-item {
		display: flex;
		align-items: center;
		padding: 22px 30px;
		border-bottom: 1px solid #ccc;

		.icon {
			width: 52px;
			height: 52px;
		}

		.middle {
			text-align: left;
			width: 300px;
		}

		.sub-content {
			display: flex;
			justify-content: space-between;
			margin-top: 10px;
		}

		.btn {
			width: 88px;
			height: 40px;
			margin-left: auto;
			background: rgba(255, 192, 50, 1);
			border: none;
		}
	}

	/deep/.index-dialog {
		/deep/.el-dialog__header {
			padding: 0 !important;
		}

		/deep/.el-dialog__body {
			padding-left: 0;
			padding-right: 0;
		}

		.dialog-title {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			height: 98px;
			box-sizing: border-box;
			padding: 12px 30px;
			background: rgba(255, 192, 50, 1);

			.slogan {
				font-size: 22px;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: rgba(255, 255, 255, 1);
				line-height: 30px;
			}

			.title {
				font-size: 28px;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: rgba(255, 255, 255, 1);
				line-height: 40px;
			}

			.allBtn {
				background: rgba(255, 155, 13, 1);
				width: 120px;
				height: 40px;
				color: rgba(255, 255, 255, 1);
				border: none;
			}
		}
	}
</style>